import { z } from 'zod'

import { broadbandPlanMemberSchema } from './plans.schemas'

export const appointmentSchema = z.object({
  id: z.string(),
  date: z.string(),
  slot: z.string(),
  earliestArrivalTime: z.string(),
  latestArrivalTime: z.string(),
  formattedArrivalTime: z.string(),
  estimatedDurationInMinutes: z.number(),
  created: z.string(),
  updated: z.string(),
  visitType: z.string(),
})

export const profileOrderSchema = z.object({
  appointments: z.array(appointmentSchema),
  id: z.string(),
  planId: z.string(),
  state: z.string(),
  needsToPaySetup: z.boolean().optional(),
  requestedOrderCompletionDate: z.string().optional(),
})

export const profileOverviewSchema = z.object({
  hasActivePlan: z.boolean(),
  // TODO: Remove the optional and default once the API is updated to always return this field
  hasCeasedService: z.boolean().default(false).optional(),
  stateDescription: z.string().optional(),
  plan: broadbandPlanMemberSchema.optional(),
  order: profileOrderSchema.optional(),
  referralCode: z.string().optional(),
})
